export const certificates = [
  {
    institutionLogo: "../../images/lakehead.png",
    title: "AWS Certified Cloud Practitioner",
    duration: "Expires Nov 8th, 2024",
    verificationCode: "R1LG9MTD3F1EQZGR",
  },
];
